import { Theme, alpha } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

import { MAX_PAGE_HEIGHT, MAX_PAGE_WIDTH } from '../../../styles/constants';
import { UiAlpha } from '../../../styles/ui-alpha';

const safeArea = {
  top: 'env(safe-area-inset-top, 0px)',
  right: 'env(safe-area-inset-right, 0px)',
  bottom: 'env(safe-area-inset-bottom, 0px)',
  left: 'env(safe-area-inset-left, 0px)',
} as const;

const bottomInset = `calc(${safeArea.bottom} + var(--vv-layout-bottom-gap, 0px))`;

export const useStyles = makeStyles<Theme>()((theme) => ({
  cookiePaper: {
    width: MAX_PAGE_WIDTH,
    maxWidth: MAX_PAGE_WIDTH,
    maxHeight:
      'calc(var(--vv-height, 100dvh) - env(safe-area-inset-top, 0px) - env(safe-area-inset-bottom, 0px))',
    margin: 0,
    marginLeft: 'auto',
    marginRight: 'auto',
    marginBottom: bottomInset,
    borderTopLeftRadius: theme.spacing(2),
    borderTopRightRadius: theme.spacing(2),
    borderBottomLeftRadius: 0,
    borderBottomRightRadius: 0,
  },
  dialogPaper: {
    width: '100%',

    maxWidth: '720px',
    margin: theme.spacing(2),
    borderRadius: '10px',

    [theme.breakpoints.down('md')]: {
      width: MAX_PAGE_WIDTH,
      maxWidth: MAX_PAGE_WIDTH,
      margin: 0,
      marginLeft: safeArea.left,
      marginRight: safeArea.right,
      top: 0,
      bottom: 'auto',
      height: MAX_PAGE_HEIGHT,
      maxHeight: MAX_PAGE_HEIGHT,
      borderRadius: 0,
    },
  },
  cookieHeader: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: theme.spacing(1.5),
  },
  cookieIconWrap: {
    ...theme.mixins.appIconTintSquare,
    backgroundColor: alpha(theme.palette.primary.main, UiAlpha.Tint),
    color: theme.palette.primary.main,
  },
  cookieIcon: {
    width: 24,
    height: 24,
  },
  content: {
    padding: theme.spacing(2),
  },
  viewToolbarClose: {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    marginBottom: theme.spacing(1),
  },
  cookieDescription: {
    fontSize: theme.typography.body1.fontSize,
    fontWeight: theme.typography.body1.fontWeight,
    lineHeight: theme.typography.body1.lineHeight,
    color:
      (theme.palette as { font?: { secondary?: string } }).font?.secondary ||
      theme.palette.text.secondary,
  },
  inlineLink: {
    display: 'inline',
    color: theme.palette.primary.main,
    cursor: 'pointer',
    padding: 0,
    margin: 0,
    textDecoration: 'underline',
    font: 'inherit',

    '&:visited': {
      color: theme.palette.primary.main,
    },

    '&:hover': {
      color: theme.palette.primary.dark,
    },
  },
  actions: {
    display: 'flex',
    justifyContent: 'flex-end',
    flexWrap: 'nowrap',
    gap: theme.spacing(1),
    padding: theme.spacing(1.5, 2, 2),
  },
  mobilePrimaryAction: {
    width: '100%',
  },
}));
